<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!currentUrl">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title> {{ 'enquetes' | nomenclatura | async }} </ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-grid class="gradient-extendido-div">
    <ion-row *ngIf="enqueteList.length" class="ion-margin-top ion-margin-bottom">
      <ion-col size="12" style="margin-left: 20px">
        <i class="fas fa-clipboard-list div-icon" style="margin-top: 2px; margin-right: 1px"></i>

        <ion-label class="color-title"> {{ 'enquetes' | nomenclatura | async }} </ion-label>
      </ion-col>
    </ion-row>

    <div class="pendetes" [ngStyle]="{'display': pendentes.length == 0 ? 'none' : 'block'}">
      <div class="item-pendentes">
        <p>{{pendentes.length == 1 ? ('PENDENTE' | translate) : ('PENDENTES' | translate)}}</p>
        <p>{{pendentes.length}}</p>
      </div>
      <ion-card
        *ngFor="let enquete of pendentes"
        (click)="abrirEnquete(enquete);"
        class="ion-no-margin ion-margin-top ion-margin-bottom"
      >
        <div class="container">
          <img [src]="enquete.imagem | image:'enquete'" />
        </div>

        <ion-card-content>
          <p class="title ellipse two-lines">{{enquete.descricao}}</p>
          <p class="subtitle">
            {{enquete.perguntas.length}} {{ enquete.perguntas.length === 1 ? ('Pergunta' | translate) : ('Perguntas' |
            translate) }}
          </p>

          <ion-row style="margin-left: -14px">
            <ion-col size="7">
              <ion-button class="btn-custom-icon btn-height" expand="block" *ngIf="enquete.status == 1">
                {{'Em Andamento' | translate}}
              </ion-button>

              <ion-button class="btn-custom-icon btn-height" expand="block" *ngIf="!enquete.status">
                {{'Responder' | translate}}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </div>

    <div class="respondido" [ngStyle]="{'display': respondidos.length == 0 ? 'none' : 'block'}">
      <div class="item-respondido">
        <p>{{respondidos.length == 1 ? ('RESPONDIDO' | translate) : ('RESPONDIDOS' | translate) }}</p>
        <p>{{respondidos.length}}</p>
      </div>
      <ion-card
        *ngFor="let enquete of respondidos"
        (click)="abrirEnquete(enquete);"
        class="ion-no-margin ion-margin-top ion-margin-bottom"
      >
        <div class="container">
          <img [src]="enquete.imagem | image:'enquete'" />
        </div>

        <ion-card-content>
          <p class="title ellipse two-lines">{{enquete.descricao}}</p>
          <p class="subtitle">{{enquete.perguntas.length}} {{'Perguntas' | translate}}</p>

          <ion-row style="margin-left: -14px">
            <ion-col size="7">
              <ion-button class="btn-success btn-height" expand="block" *ngIf="enquete.status == 2">
                {{'Respondido' | translate}}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </div>

    <sem-registro *ngIf="!enqueteList.length"></sem-registro>
  </ion-grid>
</ion-content>
